export default __webpack_public_path__ + "static/media/5.380e8d0e.jpg";